import React from "react";


const WorldMap = () => {
 
  return (
    <div className="py-5" style={{  display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "500px", }}>
  <iframe title="la Tunisie et les pays desservis" src="https://www.google.com/maps/d/u/0/embed?mid=1WnwTuGcRfWwc6-jB2howTFlyQBUlzOo&ehbc=2E312F&noprof=1&hl=en" width="640" height="480"></iframe>
      {/* Optional overlays can go here */}
    </div>
  );
};


export default WorldMap;


